import React from 'react';
import type { FormatterProps } from './type';
import { isEmpty } from 'lodash';
import { convertDateInstanceToDateString } from '../../../../helpers/dateHelper';

const LastAdmissionFormatter = ({ row }: FormatterProps) => {
  if (!row || isEmpty(row.last_episode?.previousAdmission)) {
    return <span>-</span>;
  }
  return (
    <span>
      {convertDateInstanceToDateString(
        row.last_episode?.previousAdmission.to,
      ) || '-'}
    </span>
  );
};

export default LastAdmissionFormatter;
